<h2 mat-dialog-title>Edit GeoJSON</h2>

<mat-dialog-content>
  <form id="geojsonForm" (submit)="submit($event)">
    <p>
      Edit the <a href="https://geojson.org/" target="_blank">GeoJSON</a>&nbsp;<code
        >FeatureCollection</code
      >
      of this dataset below.
    </p>
    <p>
      Each <code>feature</code> includes a <code>projection</code> property, which defaults to
      Pseudo-Mercator when omitted.
    </p>
    <mat-form-field appearance="outline">
      <mat-label>Feature collection</mat-label>
      <textarea
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="15"
        matInput
        [formField]="geojsonForm.geojson"
      ></textarea>

      @if (geojsonError(); as err) {
        <mat-error>{{ err }}</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="geojsonForm"
    [disabled]="geojsonForm().invalid() || !geojsonForm().dirty()"
  >
    Save
  </button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
